import React from "react";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";

export const breadCrumbItems = [
  {
    text: "External Firm Queue",
    key: "firm2firm-dashboard",
  },
];

export const firm2FirmFilterInitialState = {
  destination: [],
  patientId: null,
  patientName: null,
  jobId: null,
  sendingStatus: null,
  clientNames: [] ,
  createdOnFrom: null,
  createdOnTo: null,
};

export const sendingStatusOptions = [
  { key: "0", text: "SCHEDULED" },
  { key: "1", text: "BATCH CREATED" },
  { key: "2", text: "PROCESSING" },
  { key: "3", text: "COMPLETED" },
  { key: "4", text: "COMPLETED WITH ERRORS" },
  { key: "5", text: "CLOSED" },
];

const STATUS_BADGE = {
  SENDING: {
    SCHEDULED: { BG: "#555", TXT: "#E2E3E5", SHORT: "SCHEDULED", FULL: "SCHEDULED" },
    BATCH_CREATED: { BG: "#8A6D00", TXT: "#FFF3CD", SHORT: "BATCH CREATED", FULL: "BATCH CREATED" },
    PROCESSING: { BG: "#A25B00", TXT: "#FFE5CC", SHORT: "PROCESSING", FULL: "PROCESSING" },
    COMPLETED: { BG: "#155724", TXT: "#D4EDDA", SHORT: "COMPLETED", FULL: "COMPLETED" },
    ERROR: {
      BG: "#1B5E20",
      TXT: "#E8F5E9",
      SHORT: (
        <>
          COMPLETED <span style={{ color: "#FFD700", marginLeft: "5px" }}>!</span>
        </>
      ),
      FULL: "COMPLETED WITH ERRORS",
    },
    CLOSED: { BG: "#721C24", TXT: "#F8D7DA", SHORT: "CLOSED", FULL: "CLOSED" },
    UNKNOWN: { BG: "#555", TXT: "#E0E0E0", SHORT: "UNKNOWN", FULL: "UNKNOWN" },
  },
};

export const getSendingStatusBadge = (status) => {
  let cfg;

  switch (status) {
    case 0:
      cfg = STATUS_BADGE.SENDING.SCHEDULED;
      break;
    case 1:
      cfg = STATUS_BADGE.SENDING.BATCH_CREATED;
      break;
    case 2:
      cfg = STATUS_BADGE.SENDING.PROCESSING;
      break;
    case 3:
      cfg = STATUS_BADGE.SENDING.COMPLETED;
      break;
    case 4:
      cfg = STATUS_BADGE.SENDING.ERROR;
      break;
    case 5:
      cfg = STATUS_BADGE.SENDING.CLOSED;
      break;
    default:
      cfg = STATUS_BADGE.SENDING.UNKNOWN;
  }

  return (
    <CustomToolTipHost content={cfg.FULL}>
      <span
        className="study-list-report-details-text"
        style={{
          backgroundColor: cfg.BG,
          color: cfg.TXT,
          padding: "2px 6px",
          borderRadius: "6px",
          fontSize: "12px",
          whiteSpace: "nowrap",
          display: "inline-flex",
          alignItems: "center",
          height: "18px",
          marginTop: 0,
        }}
      >
        {cfg.SHORT}
      </span>
    </CustomToolTipHost>
  );
};
